import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { TopPhrasesResponse } from 'src/services/__generated__/api'

interface UseGetTopPhrasesParams {
  fromDate?: string
  limit?: number
  operators?: string
  pageId: string
  platforms?: string
  toDate?: string
  type: 'customers' | 'operators'
}

export const useGetTopPhrasesQuery = (params: UseGetTopPhrasesParams) => {
  return useQuery<TopPhrasesResponse | null>({
    enabled: !!params.pageId && !!params.type,
    queryFn: async () => {
      const { data } = await AnalyticsApi.v1Private.inboxAnalysisTopPhrasesList(
        {
          fromDate: params.fromDate,
          limit: params.limit,
          operators: params.operators,
          pageId: params.pageId,
          platforms: params.platforms,
          toDate: params.toDate,
          type: params.type,
        },
        { format: 'json' }
      )
      return data as TopPhrasesResponse
    },
    queryKey: [
      QueryKey.GET_TOP_PHRASES,
      params.pageId,
      params.type,
      params.fromDate,
      params.toDate,
      params.limit,
      params.platforms,
      params.operators,
    ],
  })
}
